export default __webpack_public_path__ + "static/media/split_img2.98e29532.svg";